<section class="flex flex-col m-2.5 grow">
    <app-management-list-header
        [asAction]="false"
        [subtitle]="`${totalItems()} ${('form' | transloco: { COUNT: totalItems() })}` | lowercase"
        [title]="'myList' | transloco"
        (search)="searchForm($event)" />
    @if (paginatedForms()) {
        <app-custom-table
            class="m-2 flex-1 min-h-0 overflow-auto"
            [columns]="tableColumns"
            (sortEvent)="onSortChange($event)">
            @for (form of paginatedForms()?.items; track form.id) {
                <tr (click)="openFormDetails(form.id)">
                    <td>
                        {{ form.name }}
                    </td>
                    <td>
                        {{ form.description }}
                    </td>
                    <td>
                        {{ form.countControls }}
                    </td>
                    <td>
                        {{ form.createdAt | date: translateService.localDate() }}
                    </td>
                </tr>
            }
        </app-custom-table>

        <app-paginator
            #paginator
            [take]="paginatedForms()!.take"
            [totalItems]="paginatedForms()!.totalItems"
            (onPageChange)="onPaginationChange($event)" />
    } @else {
        <app-no-data-to-display
            displayedMessage="noForm"
            iconSize="7x"
            information="contactUsForCreateFirstForm"
            textWidth="w-2/3" />
    }
</section>
